import { render, staticRenderFns } from "./Table.vue?vue&type=template&id=7b4ca4ba&scoped=true&"
import script from "./Table.vue?vue&type=script&lang=ts&"
export * from "./Table.vue?vue&type=script&lang=ts&"
import style0 from "./Table.vue?vue&type=style&index=0&id=7b4ca4ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b4ca4ba",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7b4ca4ba')) {
      api.createRecord('7b4ca4ba', component.options)
    } else {
      api.reload('7b4ca4ba', component.options)
    }
    module.hot.accept("./Table.vue?vue&type=template&id=7b4ca4ba&scoped=true&", function () {
      api.rerender('7b4ca4ba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Card/Things/Table.vue"
export default component.exports